/* =====================================================================
   Purelly · comportamentos próprios sobre o Dawn (15/10/2026)
   1) Carrinho: o bundle do Kaching (linha paga + linha de brinde) se comporta como UMA escolha.
      − / + pulam entre as ofertas (1 · 3 · 5) e a lixeira remove o bundle inteiro. Cada troca AJUSTA
      as linhas existentes (/cart/change.js) com as propriedades que o botão de compra do Kaching grava,
      então o preço continua calculado pelo Kaching, o − não gera AddToCart e o + só manda as unidades a mais.
   2) Barra fixa de compra na página de produto.
   ===================================================================== */
(function () {
  if (window.__plBundle) return;
  window.__plBundle = true;

  // só usado se a API do Kaching não responder
  var OFERTAS_RESERVA = {
    xxRj: [
      { id: '9ca5e80f-c07c-44d9-b569-0effbc6bb620', t: 'quantity-break', q: 1 },
      { id: 'ce8812cb-c35a-421e-99ee-0ae84405e223', t: 'bxgy', buy: 2, get: 1 },
      { id: 'ad970f0d-db26-40e0-b433-c8851fb695d2', t: 'bxgy', buy: 3, get: 2 },
    ],
  };
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function post(url, corpo) {
    return fetch(raiz + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo),
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }
  function ofertas(deal) {
    var api = window.kachingBundlesApi;
    var p = api && api.fetchDeals ? api.fetchDeals() : Promise.reject();
    return p
      .then(function (ds) {
        var d = (ds || []).find(function (x) { return x.nanoId === deal; });
        if (!d || !d.dealBars || !d.dealBars.length) throw 0;
        return d.dealBars.map(function (b) {
          return { id: b.id, t: b.dealBarType, q: b.quantity, buy: b.buyQuantity, get: b.getQuantity };
        });
      })
      .catch(function () { return OFERTAS_RESERVA[deal] || null; });
  }
  function unidades(b) { return b.t === 'bxgy' ? (b.buy || 0) + (b.get || 0) : b.q || 0; }

  // mesmo caminho de renderização que o Dawn usa ao mudar quantidade
  function renderizar(itens, json) {
    var vazio = json.item_count === 0;
    var gaveta = document.querySelector('cart-drawer');
    itens.classList.toggle('is-empty', vazio);
    if (gaveta) gaveta.classList.toggle('is-empty', vazio);
    itens.getSectionsToRender().forEach(function (s) {
      var host = document.getElementById(s.id);
      if (!host || !json.sections || !json.sections[s.section]) return;
      var alvo = host.querySelector(s.selector) || host;
      alvo.innerHTML = itens.getSectionInnerHTML(json.sections[s.section], s.selector);
    });
  }
  function atualizar(itens) {
    return post('cart/update.js', {
      updates: {},
      sections: itens.getSectionsToRender().map(function (s) { return s.section; }),
      sections_url: location.pathname,
    }).then(function (json) { renderizar(itens, json); });
  }
  // update.js só mexe nas linhas: os atributos do carrinho (bb_user_id, fbp, fbc...) ficam intactos
  function zerar(linhas) {
    var u = {};
    linhas.forEach(function (i) { u[i.key] = 0; });
    return post('cart/update.js', { updates: u });
  }
  // propriedades que o botão de compra do Kaching grava em cada linha (é delas que sai o preço da oferta)
  function propsDaOferta(bar, base) {
    var paga = { deal: base.deal, pp: base.pp, main: true, v: base.v };
    if (base.sellingPlan) paga.sellingPlan = base.sellingPlan;
    if (bar.t !== 'bxgy') { paga.bid = bar.id; return { pagas: bar.q, paga: paga, brindes: 0, brinde: null }; }
    var grupo = Math.random().toString(36).slice(2, 6);
    paga.id = grupo;
    paga.bar = bar.id;
    return { pagas: bar.buy, paga: paga, brindes: bar.get, brinde: { id: grupo, deal: base.deal, bar: bar.id, v: base.v, main: true, bxgy: true } };
  }
  function propsDe(i) {
    try { return JSON.parse((i.properties || {}).__kaching_bundles || 'null'); } catch (e) { return null; }
  }
  // Relê o carrinho a cada passo: quando o Kaching recalcula o desconto, as chaves das linhas mudam.
  // Partes da mesma linha (mesma chave) são somadas.
  function linhasAtuais(variante) {
    return fetch(raiz + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var m = {}, ordem = [];
        cart.items.forEach(function (i) {
          if (String(i.variant_id) !== String(variante)) return;
          if (!m[i.key]) { m[i.key] = { key: i.key, quantidade: 0, props: propsDe(i), item: i }; ordem.push(i.key); }
          m[i.key].quantidade += i.quantity;
        });
        var g = ordem.map(function (k) { return m[k]; });
        return {
          todas: g,
          pagas: g.filter(function (x) { return x.props && !x.props.bxgy; }),
          brindes: g.filter(function (x) { return x.props && x.props.bxgy; }),
        };
      });
  }
  function mudar(chave, quantidade, props) {
    var corpo = { id: chave, quantity: quantidade };
    if (props) corpo.properties = { __kaching_bundles: JSON.stringify(props) };
    return post('cart/change.js', corpo);
  }
  function zerarVariante(variante) {
    return linhasAtuais(variante).then(function (l) { return zerar(l.todas.map(function (g) { return g.item; })); });
  }
  function restaurar(variante, original) {
    return zerarVariante(variante).then(function () {
      return post('cart/add.js', {
        items: original.map(function (g) {
          var o = { id: g.item.variant_id, quantity: g.quantidade, properties: g.item.properties || {} };
          if (g.item.selling_plan_allocation) o.selling_plan = g.item.selling_plan_allocation.selling_plan.id;
          return o;
        }),
      });
    });
  }

  var ocupado = false;
  function trocar(li, itens, escolher) {
    if (ocupado) return;
    ocupado = true;
    li.querySelectorAll('.loading__spinner').forEach(function (el) { el.classList.remove('hidden'); });
    var lista = document.getElementById('CartDrawer-CartItems');
    if (lista) lista.classList.add('cart__items--disabled');
    var variante = li.getAttribute('data-pl-variant'), original = [];
    linhasAtuais(variante)
      .then(function (l) {
        original = l.todas;
        var base = l.pagas[0] && l.pagas[0].props;
        if (!base || !base.deal || !base.pp || l.pagas.length + l.brindes.length !== l.todas.length) throw new Error('carrinho fora do padrão do Kaching');
        var total = l.todas.reduce(function (s, g) { return s + g.quantidade; }, 0);
        var plano = l.pagas[0].item.selling_plan_allocation ? l.pagas[0].item.selling_plan_allocation.selling_plan.id : null;
        return ofertas(base.deal).then(function (bars) {
          if (!bars) throw new Error('sem ofertas');
          var alvo = escolher(bars, total); // null = remover o bundle · undefined = já está no limite
          if (alvo === undefined) return;
          if (alvo === null) return zerarVariante(variante);
          var novo = propsDaOferta(alvo, base);
          function semExtras() {
            return linhasAtuais(variante).then(function (a) {
              var extra = a.pagas[1] || a.brindes[1];
              return extra ? mudar(extra.key, 0).then(semExtras) : a;
            });
          }
          return semExtras()
            .then(function (a) { return mudar(a.pagas[0].key, novo.pagas, novo.paga); })
            .then(function () { return linhasAtuais(variante); })
            .then(function (a) {
              var b = a.brindes[0];
              if (b && novo.brindes > 0) return mudar(b.key, novo.brindes, novo.brinde);
              if (b) return mudar(b.key, 0);
              if (novo.brindes > 0) {
                var o = { id: Number(variante), quantity: novo.brindes, properties: { __kaching_bundles: JSON.stringify(novo.brinde) } };
                if (plano) o.selling_plan = plano;
                return post('cart/add.js', { items: [o] });
              }
            })
            .catch(function (e) { return restaurar(variante, original).then(function () { throw e; }); });
        });
      })
      .then(function () { return atualizar(itens); })
      .catch(function () { location.reload(); })
      .then(function () { ocupado = false; });
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var li = t.closest('#CartDrawer .cart-item[data-pl-bundle]');
      if (!li) return;
      var itens = li.closest('cart-drawer-items');
      if (!itens) return;
      var mais = t.closest('.quantity__button[name="plus"]');
      var menos = t.closest('.quantity__button[name="minus"]');
      var lixo = t.closest('cart-remove-button');
      if (!mais && !menos && !lixo) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      trocar(li, itens, function (bars, total) {
        if (lixo) return null;
        var ordem = bars.slice().sort(function (a, b) { return unidades(a) - unidades(b); });
        if (mais) return ordem.find(function (b) { return unidades(b) > total; });
        return ordem.reverse().find(function (b) { return unidades(b) < total; });
      });
    },
    true
  );
})();

/* ---------- barra fixa de compra ---------- */
(function () {
  function iniciar() {
    var sticky = document.querySelector('[data-pl-sticky]');
    if (!sticky || sticky.__pl) return;
    sticky.__pl = true;
    var principal = document.querySelector('product-form .product-form__submit');
    if (!principal) return;
    var botao = sticky.querySelector('.pl-sticky__btn');
    document.body.appendChild(sticky);
    var passou = false, visivel = false;
    function aplicar() {
      var gavetaAberta = !!document.querySelector('cart-drawer.active, cart-drawer.animate');
      var mostrar = passou && !gavetaAberta;
      if (mostrar === visivel) return;
      visivel = mostrar;
      sticky.classList.toggle('is-visivel', mostrar);
      document.body.classList.toggle('pl-sticky-ativo', mostrar);
      sticky.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
      botao.tabIndex = mostrar ? 0 : -1;
    }
    // rolagem (e não IntersectionObserver): um salto direto para o topo também precisa esconder a barra
    var pendente = false;
    function medir() {
      pendente = false;
      passou = principal.getBoundingClientRect().bottom < 0;
      aplicar();
    }
    window.addEventListener('scroll', function () {
      if (pendente) return;
      pendente = true;
      requestAnimationFrame(medir);
    }, { passive: true });
    medir();
    var gaveta = document.querySelector('cart-drawer');
    if (gaveta) new MutationObserver(aplicar).observe(gaveta, { attributes: true, attributeFilter: ['class'] });
    botao.addEventListener('click', function () { principal.click(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

/* ---------- botão "voltar ao topo" ---------- */
(function () {
  function iniciar() {
    if (document.querySelector('.pl-topo')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pl-topo';
    b.setAttribute('aria-label', 'Torna su');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    document.body.appendChild(b);
    var pendente = false;
    function medir() { pendente = false; b.classList.toggle('is-visivel', window.scrollY > 400); }
    window.addEventListener('scroll', function () { if (!pendente) { pendente = true; requestAnimationFrame(medir); } }, { passive: true });
    medir();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
